import uhmBadge from './IconUhmBadge';
import plus from './IconPlus';
import minus from './IconMinus';
import arrow from './IconArrow';
import menu from './IconMenu';
import search from './IconSearch';
import switchLink from './IconSwitchLink';
import externalLink from './IconExternalLink';
import chevron from './IconChevron';
import clear from './IconClear';
import twitter from './IconTwitter';
import facebook from './IconFacebook';
import linkedin from './IconLinkedin';
import youtube from './IconYoutube';
import close from './IconClose';
import question from './IconQuestion';
import help from './IconHelp';
import loader from './IconLoader';
import zoomIn from './IconZoomIn';
import print from './IconPrint';
import mail from './IconMail';
import sliders from './IconSliders';
import download from './IconDownload';
import copy from './IconCopy';
import volume from './IconVolume';
import warning from './IconWarning';
import sort from './IconSort';
import sortDown from './IconSortDown';
import sortUp from './IconSortUp';
import tag from './IconTag';
import chatMessage from './IconChatMessage';
import messageSquare from './IconMessageSquare';
import pen from './IconPen';
import phone from './IconPhone';
import shoppingBag from './IconShoppingBag';
import trashCan from './IconTrashCan';
import check from './IconCheck';
import checkSquare from './IconCheckSquare';
import square from './IconSquare';
import messageCircle from './IconMessageCircle';
import list from './IconList';
import shield from './IconShield';
import edit from './IconEdit';
import graph from './IconGraph';
import radioButton from './IconRadioButton';
import iconInfo from './IconInfo';
import iconAlertTriangle from './IconAlertTriangle';
import minusCircle from './IconMinusCircle';
import plusCircle from './IconPlusCircle';
import sortArrows from './IconSortArrows';
import filter from './IconFilter';
import lock from './IconLock';
import layers from './IconLayers';
import user from './IconUser';
import bell from './IconBell';
import paragraph from './IconParagraph';
export default {
    uhmBadge: uhmBadge,
    plus: plus,
    minus: minus,
    arrow: arrow,
    menu: menu,
    search: search,
    switchLink: switchLink,
    externalLink: externalLink,
    chevron: chevron,
    clear: clear,
    twitter: twitter,
    facebook: facebook,
    linkedin: linkedin,
    youtube: youtube,
    close: close,
    question: question,
    help: help,
    loader: loader,
    zoomIn: zoomIn,
    print: print,
    mail: mail,
    sliders: sliders,
    download: download,
    copy: copy,
    volume: volume,
    warning: warning,
    sort: sort,
    sortDown: sortDown,
    sortUp: sortUp,
    tag: tag,
    chatMessage: chatMessage,
    messageSquare: messageSquare,
    phone: phone,
    pen: pen,
    shoppingBag: shoppingBag,
    trashCan: trashCan,
    check: check,
    checkSquare: checkSquare,
    square: square,
    messageCircle: messageCircle,
    list: list,
    edit: edit,
    shield: shield,
    graph: graph,
    iconInfo: iconInfo,
    radioButton: radioButton,
    iconAlertTriangle: iconAlertTriangle,
    minusCircle: minusCircle,
    plusCircle: plusCircle,
    sortArrows: sortArrows,
    filter: filter,
    lock: lock,
    layers: layers,
    user: user,
    bell: bell,
    paragraph: paragraph,
};
